/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';
import {Typography} from 'onboarding-components';

import styles from '../index.module.styl';

type HeaderProps = {
  imgSrc: string;
  title: string;
  step: string;
  duration?: number;
};

export const Header = ({imgSrc, title, step, duration}: HeaderProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <img src={imgSrc} height={60} />
        <div>
          <Typography variant='eyebrowSm' className={styles.step}>
            {step}
          </Typography>
          <Typography variant='headingSm' style={{margin: 0}}>
            {title}
          </Typography>
        </div>
      </div>
      {duration && <div>{duration === 1 ? `1 minute` : `${duration} minutes`}</div>}
    </div>
  );
};
